export const errorCodes = {
  ERR_IP_BLOCKED: 1,
  ERR_LOGIN_FAILED: 2,
  ERR_2FA_AUTHENTICATION_FAILED: 3,
  ERR_PRIVATE_API: 4,
  ERR_RESOURCE_NOT_FOUND: 5,
  ERR_ACTION_FORBIDDEN: 6,
  ERR_REQUEST_PARAMS_INVALID: 8,
  ERR_PARTNER_UNKNOWN: 10,
  ERR_TOKEN_INVALID: 11,
  ERR_TOKEN_NOT_FOUND: 12,
  ERR_WRONG_PASSWORD: 14,
  ERR_2FA_SECRET_REQUIRED: 15,
  ERR_USER_BLOCKED: 19,
  ERR_DUPLICATED_INVITATION: 25,
  ERR_STILL_RELATED: 27,
  ERR_DUPLICATED_USER: 26
};
